__turbopack_context__.v({
  "actionButton": "startActions-module-scss-module__Toqo7G__actionButton",
  "bookDemoButton": "startActions-module-scss-module__Toqo7G__bookDemoButton",
  "buttonsDivider": "startActions-module-scss-module__Toqo7G__buttonsDivider",
  "scheduleEventButton": "startActions-module-scss-module__Toqo7G__scheduleEventButton",
});
